import { Injectable, inject } from '@angular/core';

import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BetslipLaunchDarklyConfiguration {
    private readonly ldService = inject(LaunchDarklyService);
    private readonly RewardPointsLaunchDarklyKey = 'BRPsInBettingJourney';

    getRewardPointsLaunchDarklyFlag(): Observable<boolean> {
        return this.ldService.getFeatureFlagValue(this.RewardPointsLaunchDarklyKey);
    }
}
